<template>
	<v-container fill-height>
		<v-layout row justify-center align-center>
			<div>
				<img :src="logo" style="filter: brightness(0%);">
				<span class="primary--text ml-2">{{ title }}</span>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: {
		logo: String,
		title: String,
	},
}
</script>
